// API Configuration
// Import from environment configuration
import API_BASE_URL from './environment.js';

export default API_BASE_URL;
